import type {CommonProps} from './types';

export default ({color = 'currentColor', size = 24, ...rest}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 24 24"
    {...rest}
  >
    <g
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1.75 6.37L22.3 2" />
      <path d="M13.6.78l-4.4.94A1.5 1.5 0 0 0 8.04 3.5l.31 1.47L15.7 3.4l-.31-1.47A1.5 1.5 0 0 0 13.6.78z" />
      <path d="M10.75 18v-7.5" />
      <path d="M15.25 18v-7.5" />
      <path d="M18.63 6h2.62l-1.38 15.87a1.5 1.5 0 0 1-1.5 1.38H7.63a1.5 1.5 0 0 1-1.5-1.38L5.1 9.37" />
    </g>
  </svg>
);
